/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserPartTimeJobDto } from '../models/UserPartTimeJobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserPartTimeJobsService {
  /**
   * 공고 찜하기
   * @returns UserPartTimeJobDto
   * @throws ApiError
   */
  public static userPartTimeJobControllerCreateUserPartTimeJob({
    partTimeJobId,
  }: {
    partTimeJobId: number;
  }): CancelablePromise<UserPartTimeJobDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/part-time-jobs/{partTimeJobId}/like',
      path: {
        partTimeJobId: partTimeJobId,
      },
    });
  }

  /**
   * 공고 찜 취소하기
   * @returns any
   * @throws ApiError
   */
  public static userPartTimeJobControllerDeleteUserPartTimeJob({
    partTimeJobId,
  }: {
    partTimeJobId: number;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/part-time-jobs/{partTimeJobId}/like',
      path: {
        partTimeJobId: partTimeJobId,
      },
    });
  }
}
